export const FIND_HOME_PROFILE_COMPANY = "FIND_HOME_PROFILE_COMPANY"
export const FIND_HOME_PROFILE_COMPANY_SUCCESS = "FIND_HOME_PROFILE_COMPANY_SUCCESS"

export const FIND_HOME_PROFILE_COMPANY_API_ERROR = "FIND_HOME_PROFILE_COMPANY_API_ERROR"
